export function getAdvertisementsRoutes() {
  return [
    {
      path: "/advertisements",
      name: "advertisements",
      component: () => import(/* webpackChunkName: advertisements-old-backend */ "./components/AdvertisementsOld.vue"),
    },
  ]
}
